import { render } from "./VisualDesignStep.vue?vue&type=template&id=e98546d0"
import script from "./VisualDesignStep.vue?vue&type=script&lang=ts"
export * from "./VisualDesignStep.vue?vue&type=script&lang=ts"
script.render = render

export default script